import React from 'react'
import { connect } from 'react-redux'
import {TypeList} from './styled'
import { ReactComponent as Bot } from 'images/icons/bott.svg'
import { ReactComponent as Human } from 'images/icons/operator.svg'

const Type = props => {
    const {count, t} = props
    const {filter, setFilter} = props.filter

    let all_human = 0, all_bot = 0

    Array.isArray(count) && count.length > 0 && count.map(x => Object.keys(x).map(y => typeof x[y] === 'object' && Object.keys(x[y]).map(z => !/\W*(closed)\W*/.test(z) && (/\W*(bot)\W*/.test(z) ? all_bot += x[y][z] : all_human += x[y][z]))))

    return <TypeList>
        <h5>{t.title}</h5>
        <div>
            <button className={filter.type === 'bot' ? 'active' : ''}
            onClick={() => setFilter({type: 'bot'})}>
                <Bot/> {t.bot}
            </button>
            
            <button className={filter.type === 'human' ? 'active' : ''}
            onClick={() => setFilter({type: 'human'})}>
                <Human/> {t.human}
            </button>
            {/*
            <button className={filter.type === 'all' ? 'active' : ''}
            onClick={() => setFilter({type: 'all'})}>
                <All/> {t.all}
            </button>*/}
        </div>
    </TypeList>
}

const mapStateToProps = state => ({
    t: state.i18nState.translations[state.i18nState.lang]['Filter']['Type']
})

export default connect(mapStateToProps)(Type)